<script lang='ts'>

    /* IMPORTS --------------------------------------------------------------------------------- */

    // CASSIOPEIA
    import {
        Button,
        FieldsetOrganizationName,
        Heading,
        InputVatId,
        OrganizationForm,
        OutputCountry,
        SESSION_ORGANIZATION,
    } from '@smatch/cassiopeia-web-components';

    // TYPES
    import type { FormComponentLegacy, Organization } from 'src/app/types';

    // CONFIG
    import { VAT_COUNTRIES } from '../config';

    /* TYPES ----------------------------------------------------------------------------------- */

    type OrganizationWithLegal = Organization & Required<Pick<Organization, 'legal'>>;

    /* PROPS ----------------------------------------------------------------------------------- */

    export let organization: OrganizationWithLegal;

    /* INTERNALS  ------------------------------------------------------------------------------ */

    let Form: FormComponentLegacy | null = null;
    let showEditForm = false;

    $: countryCode = $SESSION_ORGANIZATION?.legal?.countryCode ?? undefined;
    $: showForm = countryCode === undefined
        || (VAT_COUNTRIES.includes(countryCode) && $SESSION_ORGANIZATION?.legal?.vatId === undefined);

    const toggleEditForm = (): void => {
        showEditForm = !showEditForm;
    };

    const onSave = (): void => {
        showEditForm = false;
    };

    /* INTERFACE ------------------------------------------------------------------------------ */

    export const submit = async (): Promise<void> => {
        await (Form as FormComponentLegacy).submit();
    };
    export const isValid = (): boolean => (Form as FormComponentLegacy).isValid();

</script>

<div class = 's8-organization-data'>

    <div class = 's8-header'>

        <Heading size = 'md'>Company Details</Heading>

        {#if !showForm || showEditForm }

            <Button
                on:click = { toggleEditForm }
                color = { showEditForm ? 'neutral' : 'dark' }
                size = 'xs'
                label = { showEditForm ? 'Cancel' : 'Edit' }
            />

        {/if}

    </div>

    <OrganizationForm on:save = { onSave } action = 'update' bind:organization bind:this = { Form }>


        {#if showForm || showEditForm }

            <FieldsetOrganizationName
                bind:countryCode = { organization.legal.countryCode }
                bind:entity = { organization.legal.entity }
                name = { organization.name }
            />

            {#if organization.legal.countryCode === 'DEU' }
                <InputVatId
                    bind:value = { organization.legal.vatId }
                    countryCode = { organization.legal.countryCode}
                    isRequired = { true }
                />
            {/if}

        {:else}

            <ul>

                <li>
                    <span>Name:</span>
                    { organization.name }
                    {#if organization.legal.entity !== undefined }{ organization.legal.entity } {/if}
                </li>

                <li>
                    <span>Registered in:</span>
                    <OutputCountry countryCode = { organization.legal.countryCode } />
                </li>


                {#if organization.legal.vatId }
                    <li>
                        <span>VAT ID:</span>
                        { organization.legal.vatId }
                    </li>
                {/if}

            </ul>

        {/if}

    </OrganizationForm>

</div>


<style lang="postcss">

    div.s8-organization-data {
        div.s8-header {
            display: flex;
            justify-content: space-between;
            align-items: baseline;
        }

        ul {
            margin-bottom: 20px;
            line-height: 1.6;

            li {
                span {
                    display: inline-block;
                    min-width: 110px;
                    padding-right: 10px;
                }
            }
        }
    }

</style>